module.exports = __webpack_public_path__ + "static/media/logo-meta.5853937f.jpg";